<template>
    <b-container>
        <b-row>
            <b-col>
                <div class="my-3 p-3 bg-white rounded shadow-sm"> 
                    <h4 class="border-bottom border-gray pb-2 mb-0">Usuario</h4>    
                    <div class="media text-muted pt-3">
                        <b-form v-if="show" style="width: 100%;">
                        <b-row>
                            <b-col sm="6">
                            <b-form-group label="Nombres">
                                <b-form-input
                                v-model="form.Firstname"
                                type="text"
                                required
                                placeholder="Nombre"
                                />
                            </b-form-group>
                            </b-col>
                            <b-col sm="6">
                            <b-form-group label="Apellidos">
                                <b-form-input
                                v-model="form.Lastname"
                                type="text"
                                required
                                placeholder="Apellidos"
                                />
                            </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group label="Correo electronico">
                                <b-form-input
                                    v-model="form.Email"
                                    type="email"
                                    required
                                    placeholder="Correo electronico"
                                    disabled
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col>
                              
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Contraseña">
                                    <b-form-input
                                    v-model="form.Password"
                                    type="password"
                                    required
                                    placeholder="Contraseña"
                                    minlength="6"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Confirmar contraseña">
                                    <b-form-input
                                    v-model="form.PasswordRepeat"
                                    type="password"
                                    required
                                    placeholder="Confirmar contraseña"
                                    minlength="6"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row> 
                        <b-button  variant="primary" class="float-right boton_createch" @click="actualizar()" type="submit">
                            <i class="far fa-save"></i> Actualizar
                        </b-button>
                        </b-form>
                    </div>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Ultimos from "@/components/Empleados/Ultimos.vue";

import axios from "axios";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Ultimos,
    Loading
  },
  data() {
    return {
      isLoading: false,
      noServicio: {
        cliente: null,
        numero: ""
      },
      form: {
        Firstname: "",
        Lastname: "",
        Password: "",
        PasswordRepeat: "",
        phoneNumber: null,
        Email: "",
        
        Rol: "Cliente"
      }, 
      show: true,
      usuarios: [],
      usuario: null,  
    };
  },
  computed: { 
  },
  created() {
    this.listar();
  },
  watch: {
    "usuario": function() {
      this.form.Firstname = this.usuario.user_firstname;
      this.form.Lastname = this.usuario.user_lastname;
      this.form.Rol = this.usuario.user_rol;
      this.form.Email = this.usuario.user_email;
    }
  },
  methods: { 
    actualizar() { 
      this.isLoading = true; 
      if (this.form.Password.length > 0) { 
        if ( this.form.Password === this.form.PasswordRepeat ) { 
          axios
            .put("user/" + this.$store.state.usuario._id, {
              firstname: this.form.Firstname,
              lastname: this.form.Lastname,
              email: this.form.Email,
              rol: this.form.Rol,
              password: this.form.PasswordRepeat
            })
            .then(res => {
              this.listar(); 
              this.isLoading = false;
            })
            .catch(error => {});
        } else {
          this.makeToast("Las contraseñas no coinciden.", "Editar usuario.");
        }
      } else {
        this.isLoading = true; 
        axios
          .put(`user/${this.$store.state.usuario._id}`, {
            firstname: this.form.Firstname,
            lastname: this.form.Lastname,
            email: this.form.Email,
            rol: this.form.Rol
          })
          .then(res => {
            if (res.status === 202) {
              this.makeToast(
                "Ya existe una usuario con ese correo electrónico.",
                "Editar usuario."
              );
              this.isLoading = false;
            } else {
              this.listar(); 
              this.isLoading = false;
            }
          })
          .catch(error => {});
      }
    }, 
    listar() {
      let me = this; 
      this.isLoading = false;  
    
      axios.get('user/'+this.$store.state.usuario._id).then(function (response){   
          me.usuario=response.data;
      }).catch(function(error){
      });
      
    }, 
  }
};
</script>
<style>
a.nav-link {
  color: #333 ;
}
</style>